import { createSelector } from 'reselect'

import {
  createSelectorWithPath,
} from 'helpers/ComponentSelectorUtil'


const valuesSelectorFunc = state => state.values

export default (path) => {
  const withPath = createSelectorWithPath(path)
  const valuesSelector = withPath(valuesSelectorFunc)

  return {
    valuesSelector,
  }
}
